"use strict";
import { commonConstants } from "../_constants";

const INITIAL_SERVER_SUCCESS_MESSAGE_STATE = {
    show: false,
    messages: [],
    identity: "",
};

export function successMessageReducer(
    state = INITIAL_SERVER_SUCCESS_MESSAGE_STATE,
    action,
) {
    switch (action.type) {
        case commonConstants.AJAX_SUCCESS:
            return {
                show: true,
                messages: [action.payload, ...state.messages ],
                identity: action.identity,
            };

        case commonConstants.HIDE_AJAX_SUCCESS:
            return INITIAL_SERVER_SUCCESS_MESSAGE_STATE;
    }

    return state;
}

const INITIAL_SERVER_ERROR_MESSAGE_STATE = {
    show: false,
    messages: [],
    statusCodes: [],
    customErrors: [],
    showConfirm: false,
};

export function errorMessageReducer(
    state = INITIAL_SERVER_ERROR_MESSAGE_STATE,
    action,
) {
    switch (action.type) {
        case commonConstants.SHOW_ERROR_SERVER_MESSAGE:
            return {
                ...state,
                customErrors: [],
                show: true,
                messages: [...state.messages, action.payload.message],
                statusCodes: [...state.statusCodes, action.payload.statusCode],
            };

        case commonConstants.SHOW_ERROR_CUSTOM_SERVER_MESSAGE:
            let customErrors = [
                ...state.customErrors.filter((item) => {
                    return item.statusCode != action.payload.statusCode;
                }),
            ];

            return {
                ...state,
                customErrors: [...customErrors, action.payload],
            };

        case commonConstants.SHOW_ERROR_CONFIRM_SERVER_MESSAGE:
            return {
                ...state,
                customErrors: [],
                showConfirm: true,
                messages: [...state.messages, action.payload.message],
                statusCodes: [...state.statusCodes, action.payload.statusCode],
            };

        case commonConstants.HIDE_ERROR_CUSTOM_SERVER_MESSAGE:
            return {
                ...state,
                customErrors: [
                    ...state.customErrors.filter(
                        (item) => !action.payload.includes(item.statusCode),
                    ),
                ],
            };

        case commonConstants.HIDE_ERROR_SERVER_MESSAGE:
            return INITIAL_SERVER_ERROR_MESSAGE_STATE;

        case commonConstants.HIDE_ERROR_CONFIRM_SERVER_MESSAGE:
            return INITIAL_SERVER_ERROR_MESSAGE_STATE;
    }

    return state;
}

const INITIAL_FRONTEND_MESSAGE_STATE = {
    show: false,
    title: null,
    message: null,
    icon: null,
    needAssistance: false,
    actionLabel: null,
    action: null,
};

export function frontEndMessageReducer(
    state = INITIAL_FRONTEND_MESSAGE_STATE,
    action,
) {
    switch (action.type) {
        case commonConstants.SHOW_FRONTEND_MESSAGE:
            return {
                ...state,
                show: true,
                title: action.payload.title,
                message: action.payload.message,
                icon: action.payload.icon ? action.payload.icon : null,
                needAssistance: action.payload.needAssistance
                    ? action.payload.needAssistance
                    : false,
                actionLabel: action.payload.actionLabel,
                redirectTo: action.payload.redirectTo,
            };

        case commonConstants.HIDE_FRONTEND_MESSAGE:
            return INITIAL_SERVER_ERROR_MESSAGE_STATE;
    }

    return state;
}
